import Service from "../../../Services/index";

const MaterialExport = {
    namespaced: true,
    state: {
        table: [],
        replace_data: [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        GET_MATERIAL_EXPORT: (state, res) => {
            state.table = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        REPLACE_MATERIAL: (state, res) => {
            state.replace_data = res;
        }
    },
    actions: {
        get({commit}, page = 1) {
            return Service.exportMaterial.getMaterialExport(page).then(response => {
                commit("GET_MATERIAL_EXPORT", response);
            });
        },
        show({commit}, id) {
            return Service.exportMaterial
                .showMaterialExport(id)
                .then(response => {
                    commit("REPLACE_MATERIAL", response);
                });
        },
        create({commit}, data) {
            return Service.exportMaterial.createMaterialExport(data)

        },
        update({commit}, {id, data}) {
            return Service.exportMaterial.updateMaterialExport(id, data)

        },
        delete({commit}, id) {
            return Service.exportMaterial.deleteMaterialExport(id).then(data => {
                //console.log(data);
            });
        },
        search({commit}, {page = "", code, date}) {
            return Service.exportMaterial
                .searchMaterialExport(page, code, date)
                .then(response => {
                    commit("GET_MATERIAL_EXPORT", response);
                });
        }
    }
};
export default MaterialExport;
